import { createSelector } from "@ngrx/store";
import { IInventoryManagementState, IRemoteXPACPortalState } from "src/app/utils/interfaces/store.interfaces";

export const selectInventoryManagement = (state: IRemoteXPACPortalState) => state.inventoryManagement;

export const selectInventoryManagementPermissions = createSelector(
  selectInventoryManagement,
  (state: IInventoryManagementState) => state.permission
);

export const selectInventoryLocations = createSelector(
  selectInventoryManagement,
  (state: IInventoryManagementState) => state.locations
);

export const selectDevicesForCompany = createSelector(
  selectInventoryManagement,
  (state: IInventoryManagementState) => state.devices
);